export enum ConsultantFinderType {
  find = 'Find',
  locate = 'Locate',
}

export enum SnaConsultantFinderType {
  ByArea = 1,
  InvitationCode = 2,
}
